<div [ngStyle]="{'display': herstellersOpgehaald ? 'block' : 'none'}">
  <div *ngIf="vraag.stappenplan_detail" [innerHTML]="vraag.stappenplan_detail" class="ols-subtitle"></div>
  <div class="ols-form">
    <div class="ols-form-group">
      <div class="ols-input-zoek">
        <input class="ols-input" #PlaatsPostcode type="text" name="inputPlaats" placeholder="Plaatsnaam of postcode"
          [(ngModel)]="plaats">
        <div class="ols-icon-zoek ial-fu_045"></div>
      </div>
      <div *ngIf="plaats && searchedPlaats" class="ols-results" [hidden]="!showSearches">
        <ng-container *ngIf="searchedPlaats.length > 0">
          <div *ngFor="let plaats of searchedPlaats" class="ols-result" tappable (click)="setPlaats(plaats)">
            {{plaats.plaatsnaam}}</div>
        </ng-container>
        <p *ngIf="searchedPlaats && searchedPlaats.length <= 0 && !isSearching">Geen plaats gevonden</p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showErrorMessage" class="error-block">{{errorMessage}}</div>

<ul class="ols-radio ols-radio-mh">
  <li *ngIf="ophalenBezig"><img src="/assets/icons/ols/loading.gif" /></li>
  <li *ngFor="let reparateur of reparateurs" [id]="geefMeetid(vraag, reparateur)"
    (click)="radiobuttonClicked(reparateur.relnr, reparateur.rol)"
    (keyup.Space)="radiobuttonClicked(reparateur.relnr, reparateur.rol)"
    [ngClass]="[selectedRelnr == reparateur.relnr ? 'selected' : '']" tabindex="0">
    <div class="circle">
      <div class="outer">
        <div class="inner"></div>
      </div>
    </div>
    <div class="ols-content">
      <div class="ols-heading-5">{{reparateur.naam}}</div>
      <div *ngIf="reparateur.adres" class="ols-subtext">{{reparateur.adres}}</div>
    </div>
  </li>
</ul>
<p class="error-block" *ngIf="submitClicked && selectedRelnr === ''">Kies alsjeblieft een reparateur</p>